<template>
    <CCard class="mb-0 h-100" v-show="!storePageLoading">
        <CCardHeader>
            <!-- Title page  -->
            <h1 class="page__title">{{ $t(titlePage) }}</h1>
        </CCardHeader>
        <CCardBody class="main-card-body">
            <CContainer fluid class="p-0">
                <CRow class="justify-content-end p-2 m-0">
                    <CCol md="5">
                        <!-- Filter -->
                        <FilterDate @updateData="updateData" />
                    </CCol>
                </CRow>
                <CRow class="p-2 m-0">
                    <CCol md="12" sm="12">
                        <!-- Filter -->
                        <FilterFields
                            :fields="tables.client_leads.fields"
                            @filter="updateData"
                        />
                    </CCol>
                </CRow>
                <CRow>
                    <CCol xl="12" md="12" class="mb-4">
                        <CCard>
                            <CCardHeader>
                                <!-- Button back -->
                                <div class="d-flex">
                                    <ButtonBack class="mr-3" />
                                    <TableSettings
                                        :allFields="
                                            tables.client_leads.allFields
                                        "
                                        :activeFields.sync="
                                            tables.client_leads.fields
                                        "
                                    />
                                </div>
                            </CCardHeader>
                            <CCardBody>
                                <h6>
                                    {{ $t("leads_received_description") }}
                                </h6>
                                <CCTable
                                    size="sm"
                                    :items="tables.client_leads.items"
                                    :fields="tables.client_leads.fields"
                                    :columnFilterValue.sync="
                                        tables.client_leads.columnFilterValue
                                    "
                                    @update:column-filter-value="updateData()"
                                    @update:sorter-value="updateData()"
                                    @pagination-change="itemPerPage"
                                    :items-per-page="tables.client_leads.rows"
                                    v-bind="tables.client_leads"
                                    :resizable="true"
                                >
                                    <template #under-table>
                                        <div class="d-flex justify-content-end">
                                            <ButtonExport
                                                :endPoint="
                                                    '/delivery-campaigns/' +
                                                    uuid +
                                                    '/leads'
                                                "
                                                :baseURL="ApiSass"
                                                :adapterFilters="adapterFiltersInExport"
                                                delimiter=";"
                                                stringDelimiter="'"
                                                :table="tables.client_leads"
                                            />
                                        </div>
                                    </template>
                                    <template #_selected="{ index }">
                                        <CInputCheckbox
                                            :checked.sync="
                                                tables.client_leads.items[index]
                                                    ._selected
                                            "
                                        />
                                    </template>
                                    <template #LeadId="{ item }">
                                        <RouterLink
                                            :to="
                                                '/app/campaigns/' +
                                                item.CaptureCampaignUuid +
                                                '/leads/' +
                                                item.LeadId
                                            "
                                            >{{ item.LeadId }}</RouterLink
                                        >
                                    </template>
                                    <template #CaptureCampaignName="{ item }">
                                        <RouterLink
                                            :to="
                                                applyQueryToRoute({
                                                    route: '/app/campaings',
                                                    query: {
                                                        where: {
                                                            uuid: {
                                                                equal: item.CaptureCampaignUuid,
                                                            },
                                                        },
                                                    },
                                                })
                                            "
                                            >{{
                                                item.CaptureCampaignName
                                            }}</RouterLink
                                        >
                                    </template>
                                </CCTable>
                            </CCardBody>
                            <CCardFooter
                                v-if="tables.client_leads.total_pages > 0"
                            >
                                <div class="position-relative">
                                    <CPagination
                                        @update:activePage="updatePagination"
                                        :activePage="tables.client_leads.page"
                                        :pages="tables.client_leads.total_pages"
                                        align="center"
                                    />
                                    <CElementCover
                                        :opacity="0.8"
                                        class="bg-trasparent"
                                        v-if="tables.client_leads.loading"
                                    />
                                </div>
                            </CCardFooter>
                        </CCard>
                    </CCol>
                </CRow>
            </CContainer>
        </CCardBody>
    </CCard>
</template>

<script>
/**
 * Components
 */
import TableSettings from "£lement/TableSettings";
import FilterDate from "~/components/FilterDate";
import FilterFields from "~/components/FilterFields";
import ButtonExport from "~/components/ButtonExport";
import ButtonBack from "£lement/ButtonBack";
import CCTable from "~/components/CCTable";

/** Mixins */
import tableMixin from "~/mixins/table.js";
import pageMixin from "~/mixins/page.js";

/** Others */
import {
    cilPlus,
    cilSettings,
    cilPencil,
    cilTrash,
    cilArrowThickFromRight,
} from "@coreui/icons";

import ClientLeadsTable from "./config/tables/client_leads";
import { isReservedField } from "../../../utils/tables";

export default {
    name: "ClientLeadsPage",
    middleware: ["auth", "page"],
    mixins: [pageMixin, tableMixin],
    components: {
        FilterDate,
        FilterFields,
        TableSettings,
        ButtonBack,
        ButtonExport,
        CCTable,
    },
    icons: {
        cilPlus,
        cilSettings,
        cilPencil,
        cilTrash,
        cilArrowThickFromRight,
    },
    data() {
        return {
            tables: {
                client_leads: ClientLeadsTable,
            },
        };
    },
    computed: {
        uuid: function () {
            return this.$route.params.uuid;
        },
    },
    methods: {
        async updateData() {
            await this.updateTable({
                tableName: "client_leads",
                fetch: {
                    baseURL: process.env.VUE_APP_API_SASS,
                },
                url: `/delivery-campaigns/${this.uuid}/leads`
            });

            this.tables.client_leads.allFields =
                this.getTableAllFields("client_leads");
            this.$store.dispatch("page/updateLoading", {
                loading: false,
            });
        },

        adapterFiltersInExport(query) {
            query = {
                ...query,
                fields: this.tables.client_leads.fields
                    .filter((field) => !isReservedField(field))
                    .map((field) => {
                        return field.key;
                    }),
            };
            return query;
        },
    },
    mounted() {
        this.updateData();
    },
};
</script>

<style scoped lang="scss"></style>
